import PropTypes from 'prop-types'
import { ArrowLeft } from 'lucide-react'

/**
 * Shared screen chrome: progress line, top bar, and the screen body.
 * The cinematic arrival (rise from blur, staggered) is CSS-driven via
 * `data-arrive` on the body container, so it completes even in a
 * background tab and never gates content on JavaScript.
 */
function Shell({ label, onBack, progress = null, ink = false, bare = false, children }) {
  return (
    <div className={`screen${ink ? ' screen--ink' : ''}`}>
      {progress !== null && (
        <div className="progress-line" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress * 100)} aria-label="Assessment progress">
          <div className="progress-line__fill" style={{ width: `${Math.max(0, Math.min(100, progress * 100))}%` }} />
        </div>
      )}
      {!bare && <header className="topbar">
        {onBack ? (
          <button type="button" className="icon-btn" onClick={onBack} aria-label="Go back">
            <ArrowLeft size={20} strokeWidth={2} />
          </button>
        ) : (
          <img src="/images/logo.svg" alt="" className="logo-mark" style={{ marginLeft: 6 }} />
        )}
        <span className="topbar__label">{label}</span>
        <span />
      </header>}
      <div data-arrive style={{ display: 'contents' }}>
        {children}
      </div>
    </div>
  )
}

Shell.propTypes = {
  label: PropTypes.node,
  onBack: PropTypes.func,
  progress: PropTypes.number,
  ink: PropTypes.bool,
  bare: PropTypes.bool,
  children: PropTypes.node,
}

export default Shell
